/**
 * Get inline styles for popup behavior modes (static, fixed, smart) and positions
 * @param {string} showType - The show type: 'static', 'fixed', 'smart', or 'overlay'
 * @param {string} position - The position: 'top' or 'bottom'
 * @returns {Object} Object with popupEl, modalMaskEl, and contentEl style objects
 */
const getBehaviorStyles = (showType, position) => {
  const isTop = position === 'top';
  const isBottom = position === 'bottom';

  const styles = {
    popupEl: {},
    modalMaskEl: {},
    contentEl: {},
  };

  if (showType === 'static') {
    styles.popupEl = {
      position: 'relative',
      width: '100%',
      overflowX: 'hidden',
      zIndex: '9999999',
      pointerEvents: 'none',
    };
    styles.modalMaskEl = {
      display: 'none',
    };
    styles.contentEl = {
      position: 'relative',
      top: 'auto',
      bottom: 'auto',
      left: 'auto',
      right: 'auto',
      height: 'auto',
      pointerEvents: 'auto',
    };
  } else if (showType === 'fixed') {
    styles.popupEl = {
      pointerEvents: 'none',
    };
    styles.modalMaskEl = {
      display: 'none',
    };
    styles.contentEl = {
      position: 'fixed',
      left: '0',
      right: '0',
      zIndex: '9999999',
      pointerEvents: 'auto',
    };
    if (isTop) {
      styles.contentEl.top = '0';
      styles.contentEl.bottom = 'auto';
    } else if (isBottom) {
      styles.contentEl.top = 'auto';
      styles.contentEl.bottom = '0';
    }
  } else if (showType === 'smart') {
    styles.popupEl = {
      pointerEvents: 'none',
      overflowX: 'hidden',
    };
    styles.modalMaskEl = {
      display: 'none',
    };
    styles.contentEl = {
      position: 'fixed',
      left: '0',
      right: '0',
      zIndex: '9999999',
      pointerEvents: 'auto',
    };
    if (isTop) {
      styles.contentEl.top = '0';
      styles.contentEl.bottom = 'auto';
    } else if (isBottom) {
      styles.contentEl.top = 'auto';
      styles.contentEl.bottom = '0';
    }
  } else if (isTop) {
    // Overlay mode - apply position-based styles to contentEl
    styles.contentEl.bottom = 'auto';
  } else if (isBottom) {
    styles.contentEl.top = 'auto';
  }

  return styles;
};

module.exports = {
  getBehaviorStyles,
};
